import moment from 'moment-timezone';

import { DATE_TIME_FORMAT } from '../../../constants';
import { Button, ButtonCallNotes, ButtonGoBack } from '../../Shared';

export const Schedule3 = ({
  setIndex,
  toggleIsPlayer,
  timeInfo,
  pickerInfo,
  happenedIndex,
  appointment,
  handleFinishCall,
  handleOpen3,
  formCallNotes,
  isDialOutcomesLoading,
}) => {
  const getUserTimeZone = () => {
    const userTimeZone = moment.tz.guess();
    const userTimeZoneAbbreviation = moment().tz(userTimeZone).format('z');
    return userTimeZoneAbbreviation;
  };

  return (
    <>
      <div className="h-[386px] overflow-y-auto overflow-x-hidden rounded-[20px] bg-white/30 p-6 [&::-webkit-scrollbar-thumb]:bg-secondary/80 [&::-webkit-scrollbar-track]:bg-secondary/20 [&::-webkit-scrollbar]:w-2">
        <p className="text-brand-900 font-semibold text-[18px]/[24px] text-center">
          Does the information below look correct?
        </p>
        <div className="space-y-4 mt-6">
          <div className="flex flex-col">
            <span className="font-medium text-gray-500 text-sm">Date</span>
            <span className="text-xl font-medium border-b-secondary/20 border-b-2 pb-2">
              {pickerInfo.format(DATE_TIME_FORMAT.MMMM_Do_YYYY)}
            </span>
          </div>
          <div className="flex flex-col">
            <span className="font-medium text-gray-500 text-sm">Time</span>
            <span className="text-xl font-medium border-b-secondary/20 border-b-2 pb-2">
              {`${timeInfo} ${getUserTimeZone()}`}
            </span>
          </div>
          {happenedIndex === 0 && (
            <div className="flex flex-col">
              <span className="font-medium text-gray-500 text-sm">
                Appointment Type
              </span>
              <span className="text-xl font-medium border-b-secondary/20 border-b-2 pb-2">
                {appointment}
              </span>
            </div>
          )}
        </div>
      </div>
      <div className="flex items-center justify-between rounded-[20px] bg-white/30 px-6 py-5">
        <ButtonGoBack
          onClick={() => {
            setIndex(happenedIndex === 0 ? 19 : 3);
          }}
          disabled={isDialOutcomesLoading}
        />
        {happenedIndex === 1 && (
          <Button
            title="Finish"
            onClick={handleFinishCall}
            disabled={isDialOutcomesLoading}
          />
        )}
        {happenedIndex !== 1 && (
          <Button
            title="Yes, looks good!"
            onClick={() => {
              setIndex(5);
              toggleIsPlayer('visible');
            }}
          />
        )}
        <ButtonCallNotes
          onClick={handleOpen3}
          hasBg={formCallNotes && formCallNotes !== 'null'}
          disabled={isDialOutcomesLoading}
        />
      </div>
    </>
  );
};
